import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert,FlatList, Image, TouchableOpacity, TouchableWithoutFeedback, SafeAreaView  } from 'react-native'
import { WebView } from 'react-native-webview';
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import { Video, AVPlaybackStatus } from 'expo-av';
import Modal from "react-native-modal";


//import SwiperImage from '../Carousel/SwiperImage';
import Slideshow from '../Carousel/Slideshow';


const SCMultimedia = ({ multimedia, tipo }) => {
    const tailwind = useTailwind();

    const [isModalVisible, setModalVisible] = useState(false);

    const toggleModal = () => {
        setModalVisible(!isModalVisible);
    };

    console.log("----------------Multimediaaaaaa-----------------")
    console.log(tipo)
    console.log(multimedia["esp"])

    const [isLoading, setLoading] = useState(true);

    let tipoMultimedia = <Text>No Encontrado</Text>;

    async function setTipoMultimedia(timul) {
       console.log("tipo multimedia: ")
       console.log(timul)
       tipoMultimedia = <Text>Si encontrado</Text>
    }

    async function getTipoMultimedia()
    {
        return tipoMultimedia
    }


   if (tipo == "imagen") 
   {
        return (
            <View style={ tailwind("w-full h-full justify-around items-center") }>
                <TouchableOpacity style ={{ width: '85%',height: '85%'}}   onPress={ toggleModal }>
                    <Image
                        style = {{ width: '100%', height:'100%', resizeMode: 'contain' }}
                        source = {{ uri: multimedia["esp"]["url"], }}
                    />
                </TouchableOpacity>
                <Text/>
                <Text>{["caption"] }</Text>
                <Modal 
                    isVisible={ isModalVisible } 
                    onBackdropPress={ toggleModal }
                >
                    <SafeAreaView style={{ flex: 1 }}>
                        <Image
                            style = {{ width: '100%', height:'100%', resizeMode: 'contain' }}
                            source = {{ uri: multimedia["esp"]["url"], }}
                        />
                        <Button title="Ok" onPress={ toggleModal } />
                    </SafeAreaView>
                </Modal>
            </View>
        )
   }else if(tipo == "ppt")
   {
        return (
            <Slideshow 
                list = { multimedia["esp"]["slides"] }
                startIndex = { 1 }
            />
        )
   }else if (tipo == "video")
   {
        return (
            <View style={ tailwind("flex-1 w-full h-full justify-center items-center") }>
                {
                    Platform.OS != 'web' ?   
                    <Video
                        style={ tailwind("self-center w-4/5 h-72" ) }
                        source={{
                            uri: multimedia["esp"]["url"],
                        }}
                        resizeMode="contain"  
                        useNativeControls={true}
                    /> : 
                    <Video
                        style={ tailwind("relative w-4/5 h-auto self-center") }
                        source={{
                            uri: multimedia["esp"]["url"],
                        }}
                        resizeMode="contain"  
                        videoStyle = {{ position: "relative" }}            
                        useNativeControls={true}
                    />
                }
                <Text>{ multimedia["esp"]["caption"] }</Text>
            </View>

        )
   }else if (tipo == "iframe")
   {
        return (
            <View style={ tailwind("flex-1 w-full h-full justify-center items-center") }>
            {
                Platform.OS != 'web' ?   
                <WebView
                scalesPageToFit={true}
                bounces={false}
                javaScriptEnabled
                style={ tailwind("relative w-4/5 h-auto self-center") }
                source={{
                    html: `
                        <!DOCTYPE html>
                        <html>
                            <body>
                                <div id="baseDiv">${multimedia["esp"]["url"]}</div> //<--- add your iframe here
                            </body>
                        </html>
                    `,
                }}
                automaticallyAdjustContentInsets={false}
                /> : 
                <iframe src={multimedia["esp"]["url"]} />
            }
            <Text>{multimedia["esp"]["caption"]}</Text>
            </View>

        )
   }


}

    
const styles = StyleSheet.create({
    video: {
        alignSelf: 'center',

      }
});


export default SCMultimedia